import { MarkdownText } from '../desktopApp/longread/postblocks/whitepostblock';
import { markdownComponentsController } from '../desktopApp/longread/markdown/markdownComponentsController';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../utilites/formatLinks';
import React from 'react';
export var FormatLinkedText = function (_a) {
    var text = _a.text;
    return React.createElement(MarkdownText, { components: markdownComponentsController, rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks((text === null || text === void 0 ? void 0 : text.trim()) || ''));
};
//# sourceMappingURL=FormatLinkedText.js.mapimport { MarkdownText } from '../desktopApp/longread/postblocks/whitepostblock';
import { markdownComponentsController } from '../desktopApp/longread/markdown/markdownComponentsController';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../utilites/formatLinks';
import React from 'react';
export var FormatLinkedText = function (_a) {
    var text = _a.text;
    return React.createElement(MarkdownText, { components: markdownComponentsController, rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks((text === null || text === void 0 ? void 0 : text.trim()) || ''));
};
//# sourceMappingURL=FormatLinkedText.js.map